import React from 'react';
import { Card } from '@/components/ui/card';

/**
 * Premium Document Layout
 * Shared layout for Quotations, Sales Invoices, Purchase Orders
 * 
 * Props:
 * - title: string
 * - subtitle: string  
 * - headerActions: ReactNode (top right action buttons)
 * - leftColumn: ReactNode (main content area)
 * - rightColumn: ReactNode (summary/details cards)
 */
const PremiumDocumentLayout = ({ 
  title, 
  subtitle, 
  headerActions, 
  leftColumn, 
  rightColumn 
}) => {
  return (
    <div className="min-h-screen pb-20 md:pb-0" style={{
      background: 'linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 50%, #fce7f3 100%)'
    }}>
      {/* Header Bar - Fixed at top */}
      <div className="bg-white border-b-2 border-blue-100 px-3 sm:px-4 md:px-6 py-3 sm:py-4 sticky top-0 z-30 shadow-sm">
        <div className="max-w-[1600px] mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-4">
          <div className="min-w-0 flex-1">
            <h1 className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent truncate">
              {title}
            </h1>
            {subtitle && <p className="text-xs sm:text-sm text-gray-600 mt-0.5">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-2 w-full sm:w-auto">
            {headerActions}
          </div>
        </div>
      </div>

      {/* Main Content - CSS Grid Layout (NO ABSOLUTE POSITIONING) */}
      <div className="max-w-[1600px] mx-auto px-3 sm:px-4 md:px-6 py-4 sm:py-6">
        <div className="grid grid-cols-12 gap-3 sm:gap-4 md:gap-6">
          {/* Left Column - Main Content (8 cols on desktop, full width on mobile) */}
          <div className="col-span-12 lg:col-span-8 space-y-3 sm:space-y-4 md:space-y-6">
            {leftColumn}
          </div>

          {/* Right Column - Stacked Cards (4 cols on desktop, full width on mobile) */}
          <div className="col-span-12 lg:col-span-4">
            {/* Natural stacking with flex-col, no absolute positioning */}
            <div className="flex flex-col gap-3 sm:gap-4 md:gap-6">
              {rightColumn}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremiumDocumentLayout;